<div
  class="picker-panel"
  [class.picker-panel--mobile]="mobile()"
  [style.border-color]="view() === 'chat' ? 'transparent' : color()"
>
  <div
    class="picker-panel__header"
    [class.picker-panel__header--dark-text]="textColor() === 'dark'"
    [style.background-color]="color()"
  >
    <div class="picker-panel__header-text">
      <span class="picker-panel__title">{{
        welcomeMessage() || ('INBOX.WEBCHAT.SETTINGS.WEBCHAT_WELCOME_MESSAGE_PLACEHOLDER' | translate)
      }}</span>
      <span class="picker-panel__subtitle">
        @if (view() === 'chat') {
          <button
            class="picker-panel__back"
            (click)="back.emit()"
            [attr.aria-label]="'INBOX.WEBCHAT.WIDGET.MULTI_LOCATION.BACK_ARIA_LABEL' | translate"
          >
            <svg xmlns="http://www.w3.org/2000/svg" height="16px" viewBox="0 0 24 24" width="16px" fill="currentColor">
              <path d="M0 0h24v24H0z" fill="none" />
              <path d="M20 11H7.83l5.59-5.59L12 4l-8 8 8 8 1.41-1.41L7.83 13H20v-2z" />
            </svg>
          </button>
          {{
            'INBOX.WEBCHAT.WIDGET.MULTI_LOCATION.CHATTING_WITH' | translate: { name: $safeNavigationMigration(selectedLocation()?.businessName) }
          }}
        } @else {
          <span class="picker-panel__status-dot"></span>
          {{ 'INBOX.WEBCHAT.WIDGET.WE_RESPOND_IMMEDIATELY' | translate }}
        }
      </span>
    </div>
    @if (!embedded()) {
      <button
        class="picker-panel__close"
        (click)="closeClicked.emit()"
        [attr.aria-label]="'INBOX.WEBCHAT.WIDGET.CLOSE_WIDGET' | translate"
      >
        <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 0 24 24" width="24px" fill="currentColor">
          <path d="M0 0h24v24H0z" fill="none" />
          <path
            d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
          />
        </svg>
      </button>
    }
  </div>

  @if (view() === 'picker') {
    @if (showSearch()) {
      <div class="picker-panel__search">
        <glxy-form-field [showLabel]="false" prefixIcon="search" bottomSpacing="none">
          <input
            matInput
            type="search"
            [placeholder]="'INBOX.WEBCHAT.WIDGET.MULTI_LOCATION.SEARCH_PLACEHOLDER' | translate"
            [attr.aria-label]="'INBOX.WEBCHAT.WIDGET.MULTI_LOCATION.SEARCH_ARIA_LABEL' | translate"
            (input)="onSearch($event)"
          />
        </glxy-form-field>
      </div>
    }

    <div class="picker-panel__body">
      @if (isLoading()) {
        <div class="picker-panel__loading">
          <glxy-loading-spinner></glxy-loading-spinner>
        </div>
      } @else if (error()) {
        <div class="picker-panel__empty">
          <p>{{ 'INBOX.WEBCHAT.WIDGET.MULTI_LOCATION.ERROR_GENERIC' | translate }}</p>
          <button mat-stroked-button (click)="retry.emit()">
            {{ 'INBOX.WEBCHAT.WIDGET.MULTI_LOCATION.TRY_AGAIN' | translate }}
          </button>
        </div>
      } @else if (locations().length === 0) {
        <div class="picker-panel__empty">
          <p>{{ 'INBOX.WEBCHAT.WIDGET.MULTI_LOCATION.NO_LOCATIONS' | translate }}</p>
        </div>
      } @else {
        @for (loc of locations(); track loc.namespace) {
          <button class="location-card" (click)="selectLocation.emit(loc)">
            <div class="location-card__text">
              <span class="location-card__name">{{ loc.businessName }}</span>
              @if (loc.address) {
                <span class="location-card__address">{{ loc.address }}</span>
              }
            </div>
            <mat-icon class="location-card__chevron">chevron_right</mat-icon>
          </button>
        }
      }
    </div>

    @if (hasPrev() || hasMore()) {
      <div class="picker-panel__pagination">
        <button
          mat-icon-button
          [disabled]="!hasPrev()"
          (click)="prevPage.emit()"
          [attr.aria-label]="'INBOX.WEBCHAT.WIDGET.MULTI_LOCATION.PREV_PAGE_ARIA_LABEL' | translate"
        >
          <mat-icon>chevron_left</mat-icon>
        </button>
        <span class="picker-panel__page-label">{{
          'INBOX.WEBCHAT.WIDGET.MULTI_LOCATION.PAGE' | translate: { page: currentPage() }
        }}</span>
        <button
          mat-icon-button
          [disabled]="!hasMore()"
          (click)="nextPage.emit()"
          [attr.aria-label]="'INBOX.WEBCHAT.WIDGET.MULTI_LOCATION.NEXT_PAGE_ARIA_LABEL' | translate"
        >
          <mat-icon>chevron_right</mat-icon>
        </button>
      </div>
    }

    @if (showFooterContent()) {
      <mat-divider></mat-divider>
      <div class="picker-panel__footer">
        @if (poweredByName()) {
          @if (poweredByUrl()) {
            <a [href]="poweredByUrl()" target="_blank" rel="noopener noreferrer" class="picker-panel__footer-link">
              {{ 'INBOX.WEBCHAT.WIDGET.MULTI_LOCATION.POWERED_BY' | translate: { name: poweredByName() } }}
            </a>
          } @else {
            <span>{{ 'INBOX.WEBCHAT.WIDGET.MULTI_LOCATION.POWERED_BY' | translate: { name: poweredByName() } }}</span>
          }
        }
      </div>
    }
  }

  @if (view() === 'chat') {
    <div class="chat-body">
      <div class="chat-body__inset">
        <webchat-box
          [embedded]="true"
          [fullView]="true"
          [absolutePosition]="false"
          [hideEmptyState]="true"
          [currentParticipantId]="currentParticipantId()"
          [messageGroups]="messageGroups()"
          [messages]="messages()"
          [processing]="processing()"
          [isReplying]="isReplying()"
          [webchatColor]="color()"
          [webchatTextColor]="textColor()"
          [webchatAccentColor]="accentColor()"
          [webchatAccentTextColor]="accentTextColor()"
          [position]="position()"
          [assistantName]="$safeNavigationMigration(selectedLocation()?.businessName)"
          [assistantAvatarUrl]="assistantAvatarUrl()"
          [showFooterContent]="showFooterContent()"
          [poweredBy]="{ name: poweredByName(), url: poweredByUrl() }"
          [placeholder]="placeholder()"
          (sentMessage)="sentMessage.emit($event)"
        ></webchat-box>
      </div>
    </div>
  }
</div>
